// @ts-strict
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SaveRequired } from '@base/lm-base';
import { LMHtmlPageComponent } from '@html/lm-html-page.component';
import {Component, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {LMBaseComponent, LMFormComponent, LMListComponent, LMPageComponent} from "@app/components";
import {HtmlUrlDocHost} from "@html/lm-html-url-doc-host";

@Injectable()
export class DeactivateGuard  {

  constructor() {
    // no-op
  }

  canDeactivate(
    component: SaveRequired,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component) {
      if (component instanceof LMHtmlPageComponent) {
        const htmlPageComp: LMHtmlPageComponent = <LMHtmlPageComponent>component;
        // if we get here we know the route is <dataArea>/<webApp>/html/url?

        if (!htmlPageComp.htmlDocComponent || !nextState) {
          return true;
        }
        const currentUrl: string =  htmlPageComp.htmlDocComponent.getLoadedUrl();
        const possibleNextUrl: string = nextState.url;

        const currentUrlPath: string = currentUrl.indexOf('?') >= 0 ? currentUrl.substring(0, (currentUrl.indexOf('?'))) : currentUrl;
        const possibleNextUrlPath: string = possibleNextUrl.indexOf('?') >= 0 ? possibleNextUrl.substring(0, possibleNextUrl.indexOf('?')) : '';

        // const currentUrlParams: string = currentUrl.indexOf('?') >= 0 ? currentUrl.substring((currentUrl.indexOf('?') + 1)) : currentUrl;
        // const possibleNextUrlParams: string = possibleNextUrl.indexOf('?') >= 0 ? possibleNextUrl.substring((possibleNextUrl.indexOf('?') + 1)) : '';

        if (currentUrlPath === possibleNextUrlPath) {
          // ok now we know we are going to try to load the LMHtmlPageComponent because the paths match.
          // Also - We dont want to keep firing the same event if the params are the same.
          // todo stan, none of these are used, maybe check with brent if this is needed - Phillip 3/13/23
          // only load when params are changed
          // let possibleNextUrlParamsArray: Array<string>  = possibleNextUrlParams.split('&');
          // possibleNextUrlParamsArray = this.lmUrlUtilService.stripCSKs(possibleNextUrlParamsArray);

          setTimeout(() => {
            htmlPageComp.htmlDocComponent.setLoadedUrl(possibleNextUrl);
            htmlPageComp.htmlDocComponent.fireSameUrlRequested(possibleNextUrl);
          });
          return false;
        }
        else
        {
          htmlPageComp.htmlDocComponent.clearHtmlUrlListeners();
        }
      }

      let frames: HTMLCollectionOf<HTMLFrameElement>;
      frames = this.getFrames(component);
      if (frames && LMBaseComponent.isHtmlDocHost(component)) {
        const htmlDocHostComp = component as Component as HtmlUrlDocHost;

        Array.from(frames).forEach((frame, index: number) => {
            const identifer = frames[index].getAttribute("identifier");
            const frameRef: LMHtmlUrlDocData = htmlDocHostComp?.getHtmlUrlDocService().getFrameRefs()[identifer];
            if (frameRef) {
                frameRef.htmlUrlDocComponent?.clearHtmlUrlListeners();
            }
        });
      }

      return component.allowPageNavigation(nextState);
    }

    return true;
  }

  private getFrames(component): HTMLCollectionOf<HTMLFrameElement> {
      let frames: HTMLCollectionOf<HTMLFrameElement>;

      if (LMBaseComponent.isHtmlDocHost(component)) {
          frames = component?.elementRef?.nativeElement.getElementsByTagName("iframe");
      }
      return frames
  }
}
